import { Div, Text } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'

const Card = ({
  title,
  description,
  src,
  alt
}) => {

  const { isMobile } = useResponsive()

  return (
    <Div
      border='1px solid #E4E4E7'
      backgroundColor='white'
      borderRadius={16}
      overflow='hidden'
      height='100%'
    >
      <Div
        as='img'
        width='100%'
        src={src}
        alt={alt}
      />
      <Text size={isMobile ? 'xl' : '2xl'} color='headline' align='center'>
        {title}
      </Text>
      <Div width='80%' maxWidth={430} margin='16px auto 48px'>
        <Text size='sm' align='center'>
          {description}
        </Text>
      </Div>
    </Div>
  )
}

export default Card